export enum SuperuserRole {
  RoleUser = "ROLE_USER",
  RoleAdmin = "ROLE_ADMIN",
}
